export const baseUrl = 'https://facilimo.pt';
export const appUrl = 'https://app.facilimo.pt';
export const apiUrl = 'https://api.facilimo.pt';
export const google = {
    clientId: '80577240297-m013um4b4hpttqla0phhop4qgi038ag6.apps.googleusercontent.com',
    redirectUri: 'https://facilimo.pt/auth/google/callback'
}



// WEBPACK FOOTER //
// ./src/vars.js